import ReactGA from 'react-ga4';

const TRACKING_ID = 'G-JD87LGDMXX';

export const initGA = () => {
  ReactGA.initialize(TRACKING_ID, {
    debug: process.env.NODE_ENV === 'development'
  });
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = (category, action, label = null) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label
  });
};

// Funzioni specifiche per il tuo sito Finday
export const trackEventView = (eventId, eventTitle) => {
  trackEvent('Event', 'View', `${eventId} - ${eventTitle}`);
};

export const trackSearch = (searchQuery) => {
  trackEvent('Search', 'Query', searchQuery);
};

export const trackMapInteraction = (action) => {
  trackEvent('Map', action);
};

export const trackFilterUsage = (filterType, filterValue) => {
  trackEvent('Filter', filterType, filterValue);
};

export const trackLocationRequest = () => {
  trackEvent('Location', 'Request');
};

export const trackNearbyEventsView = (eventCount) => {
  trackEvent('NearbyEvents', 'View', `${eventCount} events`);
};

export const trackOverlappingEventsPopup = (eventCount) => {
  trackEvent('OverlappingEvents', 'Popup', `${eventCount} events`);
};

export const trackDonationClick = () => {
  trackEvent('Donation', 'Click');
};
